import React from 'react';

import { PageId } from 'utils/ubi/pageId';

import InternalLink, { LinkProps } from './InternalLink';

const childCategoryLink = (parentCategorySlug: string, childCategorySlug: string) => (market: string) =>
  `/${market}/${parentCategorySlug}/${childCategorySlug}/`;

interface CategoryLinkProps extends LinkProps {
  parentCategorySlug: string;
  childCategorySlug: string;
}

const ChildCategoryLink = ({ parentCategorySlug, childCategorySlug, ...props }: CategoryLinkProps) => (
  <InternalLink
    toPage={PageId.OldChildCategory}
    hrefFun={childCategoryLink(parentCategorySlug, childCategorySlug)}
    {...props}
  />
);

export default ChildCategoryLink;
